enum ColorMode {
  DarkMode = "DarkMode",
  LightMode = "LightMode",
}

export default ColorMode;
